import { IconProps } from "./IconProps";

const TransactionIcon: React.FC<IconProps> = ({ width = 24, height = 24 }) => {
  return (
    <svg width={width} height={height} fill="none" viewBox="0 0 24 24">
      <path
        fill={"currentColor"}
        d="M4 20a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 1 17v-3h3V0h15v17q0 1.25-.875 2.125A2.9 2.9 0 0 1 16 20zm12-2q.424 0 .712-.288A.97.97 0 0 0 17 17V2H6v12h9v3q0 .424.287.712.288.288.713.288M7 7V5h9v2zm0 3V8h9v2z"
      ></path>
    </svg>
  );
};
export default TransactionIcon;
